import { Modal, ModalBody } from "reactstrap";
import { useEffect, useState } from "react";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { useCollaboratorsActions } from "../../../../services/actions/collaborators.actions";
import { HiOutlinePlusCircle } from "react-icons/hi";
import { TEST_ID } from "../../../../helpers/constants";
import { useSelectionProcessAction } from "../../../../services/actions/selection-process.actions";
import toast from "react-hot-toast";

const AddCollaboratorModal = (props) => {
  const {
    open,
    toggle,
    update,
    clientId,
    handleOpenModal,
    idProcessSelection,
    listCollaborators,
    rutNewCollab
  } = props;
  const { sendInvitation, listCollaborator } = useCollaboratorsActions();
  const { updateSelectionProcess } = useSelectionProcessAction();
  const [collaborators, setCollaborators] = useState([]);
  const [newSelectedCollab, setNewSelectedCollab] = useState([]);
  const [showCollaborators, setShowCollaborators] = useState(false);
  const [filteredCollaborators, setFilteredCollaborators] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const getCollaborators = async () => {
    const response = await listCollaborator({ clientId });
    setCollaborators(response?.data);
    setFilteredCollaborators(response?.data);
  };

  const handleDeleteCollaborator = (id) => {
    setNewSelectedCollab(
      newSelectedCollab.filter((collab) => collab.id !== id)
    );
  };

  const handleSelectAllCollaborators = (e) => {
    if (e.target.checked) {
      setNewSelectedCollab([...collaborators]);
    } else {
      setNewSelectedCollab([]);
    }
  };

  const isCollaboratorSelected = (id) => {
    return newSelectedCollab.some((collab) => collab.id === id);
  };

  const handleSelectCollaborator = (id) => {
    const selectedCollab = collaborators.find((collab) => collab.id === id);
    if (selectedCollab) {
      if (isCollaboratorSelected(id)) {
        setNewSelectedCollab(
          newSelectedCollab.filter((collab) => collab.id !== id)
        );
      } else {
        setNewSelectedCollab((prevValues) => [...prevValues, selectedCollab]);
      }
    }
  };

  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setShowCollaborators(false);
    }
  };

  const handleAddCollaborator = (event) => {
    event.preventDefault();
    const idCollaborators = newSelectedCollab.map(
      (collaborators) => collaborators.id
    );
    const collaboratorsArr = newSelectedCollab.map((collaborators) => ({
      clientId,
      id: collaborators.id,
    }));
    const data = {
      id: idProcessSelection,
      collaborators: collaboratorsArr,
    };

    updateSelectionProcess(data, (res)=>{
      if(res.status === 400){
       return toast.error('El número de invitados supera la cantidad de test disponibles, intenta quitando algunas personas de la lista.', {duration:6000})
      }

      if(res.status === 200){
        sendInvitation(
          {
            testID: `${TEST_ID}`,
            collaboratorIDs: idCollaborators,
          },
          () => {
            toast.success("Se han agregado los colaboradores al proceso.", {
              duration: 4500,
            });
            update();
            toggle();
          }
        );
      }
    })
  };

  useEffect(() => {
    getCollaborators();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFilteredCollaborators(
      collaborators.filter(
        (collab) =>
          collab.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          collab.email.toLowerCase().includes(searchTerm.toLocaleLowerCase())
      )
    );
  }, [searchTerm, collaborators]);

  useEffect(()=>{
    setFilteredCollaborators(listCollaborators)
    const newAddedCollaborator = listCollaborators.find(
      (collaborators) => collaborators.rut === rutNewCollab
    );
    if (newAddedCollaborator)
      if (
        !newSelectedCollab.find(
          (selected) => selected.rut === newAddedCollaborator.rut
        )
      ) {
        setNewSelectedCollab((prevValues) => [
          ...prevValues,
          newAddedCollaborator,
        ]);
      }
      //eslint-disable-next-line
      }, [listCollaborators])
    

  return (
    <>
      <Modal isOpen={open} toggle={toggle}>
        <div className="gm-modal-header">
          <div className="gm-modal-title-container">
            <div className="gm-modal-title">Invitar</div>
          </div>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={toggle}
          />
        </div>
        <ModalBody>
          <form>
            <div className="gm-step-container">
              <div
                className="gm-selection-searchbar-collab"
                onFocus={() => setShowCollaborators(true)}
                onBlur={handleBlur}
                tabIndex={-1}
              >
                <input
                  onClick={() => setShowCollaborators(true)}
                  type="text"
                  placeholder="Buscar por nombre o correo"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                />
                {showCollaborators && (
                  <ul>
                    <li>
                      <div>
                        <span>
                          Seleccionar los Colaboradores (
                          {newSelectedCollab.length})
                        </span>
                        <span></span>
                      </div>
                      <div>
                        Seleccionar todos
                        <input
                          type="checkbox"
                          onChange={handleSelectAllCollaborators}
                          checked={
                            collaborators.length > 0 &&
                            newSelectedCollab.length === collaborators.length
                          }
                        />
                      </div>
                    </li>
                    {filteredCollaborators.map((collab, index) => (
                      <li key={index}>
                        <div>
                          <span>{`${collab.name} ${collab.surname}`}</span>
                          <span>{collab.email}</span>
                        </div>
                        <div>
                          {collab.collaboratorInternal ? "Interno" : "Externo"}
                          <input
                            type="checkbox"
                            checked={newSelectedCollab.some(
                              (selected) => selected.id === collab.id
                            )}
                            onChange={() => handleSelectCollaborator(collab.id)}
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="gm-selection-add-collab">
                <button
                  type="button"
                  onClick={() => handleOpenModal("createCollab")}
                >
                  <HiOutlinePlusCircle /> Nuevo Colaborador
                </button>
              </div>
              {newSelectedCollab.length !== 0 && (
                <ul>
                  {newSelectedCollab.map((collab) => (
                    <li>
                      <div>
                        <span> {`${collab.name} ${collab.surname}`} </span>
                        <span> {collab.email}</span>
                      </div>
                      <div>
                        {" "}
                        {collab.collaboratorInternal
                          ? "Interno"
                          : "Externo"}{" "}
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          onClick={() => {
                            handleDeleteCollaborator(collab.id);
                          }}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              )}{" "}
            </div>
            <div className="gm-modal-buttons">
              <button
                type="button"
                className="gm-secondary-button"
                onClick={() => toggle()}
              >
                Cancelar
              </button>
              <ButtonLoading
                className="gm-primary-button"
                type="submit"
                buttonLabel="Invitar"
                onClick={(e) => handleAddCollaborator(e)}
                disabled={newSelectedCollab.length === 0}
              />
            </div>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddCollaboratorModal;
